const COMMONDOCUMENTSROUTES = {
  UPLOADFILE: `commondocuments/reference/document/`,
  GETFILE: `commondocuments/reference/documents/`,
};

export default COMMONDOCUMENTSROUTES;
